// / <reference path="../../node_modules/msal/lib-es6/UserAgentApplication.d.ts" />
// import * as Msal from 'msal';
// import {Utils} from 'msal/lib-commonjs/Utils';
import { PublicClientApplication } from "@azure/msal-browser";
import { CookieStorage } from "@azure/msal-browser/dist/cache/CookieStorage";



export  class Auth {

  private applicationConfig: any = {
    //AzureAD 直接認証
    // clientID: '70322cbe-5afc-40e1-84d9-d7cfd03df662',
    // scopes: ['api://70322cbe-5afc-40e1-84d9-d7cfd03df662/access_as_user'],

    //AzureAD B2C認証
    //id_tokenのみを利用する～アクセス権限はアプリ側で制御するのでaccess_token(scope)は利用しない
    //AzureAD直接認証の場合は適当なスコープを定義するとaccess_tokenを取得できたが、B2C認証ではパーミッションエラーで取得できなかった。
    //acquireTokenSilent()とacquireTokenRedirect()でScopeを渡す際にclientIDを指定するとid_tokenを取得できる。トリッキーな仕様なので注意。
    // clientID: '8cfbe406-6a59-4534-acd9-3cf5d0841624',
    // authority:'https://codexid.b2clogin.com/codexid.onmicrosoft.com/B2C_1A_signup_signin_aad',
    // scopes: null,
  };

  public app: PublicClientApplication;
  public userId : string = '';
  public userName: string = '';
  public clientID :string ;
  // public authority:string;
  public auth :string = '';
  public scopes = ["openid","profile","offline_access","https://codexid.onmicrosoft.com/backlog/user_impersonation"];
  public state = '';
  constructor(clientID:string) {

    //app.s-flow.netからtenantへのリダイレクト～#パラメーターなどは想定していない
    if (process.env.NODE_ENV == 'production' && location.host.split('.')[0]=='app'){      
       var appURL = document.cookie.match(/appURL=([^;]*)/);
       if (appURL && appURL[1]) {
        var redirectURL =  location.href.replace(location.host, appURL[1]);
        if (redirectURL.indexOf("?") > -1) redirectURL = redirectURL.substring(0,redirectURL.indexOf("?"));
        //ユーザーID
        var appUser = document.cookie.match(/appUser=([^;]*)/);
        if (appUser && appUser[1]) {
          const url = new URL(location.href);    
          var page =  url.searchParams.get('page');
          var description = '<a href="https://support.s-flow.net/ja/articles/' + page + '">サポートサイト</a>から<a href="' + redirectURL + '">テナント</a>への遷移がありました';
          var email = decodeURIComponent(appUser[1]);
          navigator.sendBeacon("https://teams.s-flow.net/support",JSON.stringify({email:email,description:description}));        
        }
        //テナントURLにリダイレクト(サーバー専有プラン考慮済み)
        location.href = redirectURL;
       } else {
        //サインアップにリダイレクト
        location.href = location.href.replace("app.","signup.");
       }
       //後続処理を回避。Signin.Vueに遷移するがローディング表示のままにする
       this.ssoStarted = true; 
       return;
    }

    //MSALリダイレクトバック時はlocation.hashのstateパラメータから当初のURLを取得し、再度リダイレクトする～oauthの場合はクエリパラメーターなのでこれまでと同じ挙動
    var redirectBack = false;
    if (location.hash && location.hash.indexOf('state') > -1){
      var parameters = new URLSearchParams(location.hash.substring(1));
      var hash = parameters.get('state');
      var temp = hash.split("|") as string[];
      var initiationURL = temp.length > 1 ? temp[1]: null;      
      if (initiationURL.indexOf('#')　> -1) initiationURL = initiationURL.substring(0,initiationURL.indexOf('#')); //#以降を取り除く
      if (initiationURL && location.href.startsWith(initiationURL) == false) {
        location.href = initiationURL + location.hash;      
        redirectBack = true;
      }
    }

   //共有リダイレクトURL処理
    var redirectURL = location.origin;
    var state = null;

    if (process.env.NODE_ENV == 'production' && redirectBack == false){
         var subdomain = location.host.split('.')[0];
         if (subdomain == "login") {
           //stateパラメーターからtenantIdを取得してリダイレクト
           location.href = location.href.replace("login",this.getTenantIdFromState());
          // location.href = this.getTenantHref();
         } else {
           //stateパラメーターをセットしてredirectURLをlogin.code-x.co.jpなどに変更
           redirectURL = redirectURL.replace(subdomain,"login");
          //  redirectURL = redirectURL.replace(subdomain,"login") + '?tenant=' + subdomain;
           state = subdomain;
         }
    } 
    //当初のURLを保存(テナントIDを保持する形から変更)
    state = location.href.indexOf('#') > -1 ? location.href.substring(0,location.href.indexOf('#')): location.href;//#以降を取り除く
    state = state.replace('signin_local_signup',''); //s-flowアカウントの新規登録時に戻るように変更
    this.clientID = clientID;
    // this.authority = authority;
    
    this.auth = localStorage.getItem('auth');

    this.state = state; //stateを保持


    //エージェントの設定～navigateToLoginRequestUrl:falseを設定しないとリダイレクトバックされた時にid_tokenの処理が行われない
    //this.app = new Msal.UserAgentApplication(this.applicationConfig.clientID,null,this.redirectCallBack,{ storeAuthStateInCookie: true,redirectUri:location.origin, cacheLocation: "localStorage", navigateToLoginRequestUrl:false,postLogoutRedirectUri:''} );
    //BadRequest問題はcookieに依存していると推定されるのでstoreAuthStateInCookieをfalseに変更してみる

    const msalConfig = {
      auth: {
        clientId: this.clientID,
        authority: this.auth,
        knownAuthorities: ["codexid.b2clogin.com"], // B2C では必須
        redirectUri: redirectURL,
        navigateToLoginRequestUrl:false,
        postLogoutRedirectUri:window.location.href
      },
      cache: {
        cacheLocation: "localStorage", // PWA や iOS Safari 対策に推奨
        storeAuthStateInCookie: false,
      },
    };
    this.app = new PublicClientApplication(msalConfig);

  }
  //this.app.initialize()を待機する必要があるため分離
  async initialize(){

    //cacheエンクリプションキーを喪失している場合は復元する～セッション切れでログアウトする問題を解消する
    var match = document.cookie.match(/msal\.cache\.encryption=([^;]+)/);
    const backup = localStorage.getItem("msal.cache.encryption.backup");    
    if (!match && backup) {
      const cookie = `msal.cache.encryption=${backup};domain=${location.hostname}; path=/; samesite=none;secure;`;
      document.cookie = cookie;
    }

    await this.app.initialize();

    //initialize()で初期化されたcacheエンクリプションキーをバックアップする
    match = document.cookie.match(/msal\.cache\.encryption=([^;]+)/);
    if (match) {
      localStorage.setItem("msal.cache.encryption.backup", match[1]);
    }

    await this.app.handleRedirectPromise().then(response=>{
      if (response){
        this.app.setActiveAccount(response.account);
      }
    }).catch(error　=> {
      if (error.message && error.message.indexOf("AADB2C90118") > -1) {
        //パスワードリセットポリシー対応
        localStorage.setItem("msal.login.error", error.message + ":" + error.errorCode);
        console.log("Forgot Password イベントを localStorage に保存");      
      }
    });

    //this.app = new Msal.UserAgentApplication(this.clientID,this.auth,this.redirectCallBack,{validateAuthority:false, storeAuthStateInCookie: false,redirectUri:redirectURL, cacheLocation: "localStorage", navigateToLoginRequestUrl:false,postLogoutRedirectUri:window.location.href,state:state} );    
    const user = this.app.getActiveAccount();
    if (user){
      //パスワード変更と新規登録時はtfp(policy)が異なるためログインし直す～logoutしていないせいかnonceミスマッチが発生する
      //tfpはidTokenを発行した時のpolicy。
      // var tfp = user.idToken.hasOwnProperty('tfp') ? (user.idToken as any).tfp:'';
      if (this.auth.endsWith('B2C_1_local_pwdreset2') ||this.auth.endsWith('B2C_1_local_signup2')){
          // this.login('B2C_1_local');          
          var newPolicy =  'https://codexid.b2clogin.com/tfp/codexid.onmicrosoft.com/B2C_1_local2';
          // this.app.authority = newPolicy;
          localStorage.setItem('auth',newPolicy);          
          this.app.acquireTokenRedirect({scopes: this.scopes, authority: newPolicy,state:this.state});
          return; //他の処理に流れないようにしておく
      } else {
        //ログイン済みの場合はポリシーをセットする
        this.setPolicy((user.idTokenClaims as any).tfp);
      }
      this.userId = (user.idTokenClaims as any).emails[0];//user.displayableId;
       localStorage.setItem('userId',this.userId);  
    } 
    //以前のログオンが残っている場合
    if (user != null && this.auth == null) this.logout();
    //シングルサインオンを試行する ["policy=B2C_1_office365","B2C_1_office365"]
    var policy = document.cookie.match(/policy=([^;]*)/);
    if (user == null && policy) {
      this.ssoStarted = true;
      this.login(policy[1]);
    }

  }
  public ssoStarted = false; //リダイレクト処理の前に通信が発生するため待機時間が発生する
　
  getTenantHref(){
    //stateだとパスワード変更や新規登録のキャンセル時にリダイレクトバックに失敗する
    const url = new URL(location.href);    
    var tenantId =  url.searchParams.get('tenant');
    if (tenantId){
      url.hostname = url.hostname.replace('login',tenantId);
      url.searchParams.delete('tenant');
    } else {
      url.hostname = url.hostname.replace('login','signup');      
    }
    return url.href;
  }


  getTenantIdFromState(){

    //oauthのコールバック=>stateパラメータの一つ目を返す    
    const params = new URLSearchParams(location.search);
    const state = params.get('state');
    if (state && state.split("|").length > 0) return  state.split("|")[0];


    //hash(#)の先頭のstateパラメーターの|で区切られた2つ目
    //stateパラメーターにtenantIdが埋め込まれていない場合はsignupにリダイレクト
    // var hash = decodeURI(location.hash);    
    // hash = hash.substring(1, hash.indexOf("&"));
  
    var parameters = new URLSearchParams(location.hash.substring(1));
    var hash = parameters.get('state');
    var temp = hash.split("|");
    if (temp.length > 1) return temp[1];
    else "signup";
  }

  isLoggedIn(){
    const user = this.app.getActiveAccount();
    return user != null ;
  }

  redirectCallBack(errorDesc: any, token: any, error: any, tokenType: any){
    //トークン更新時(acquireTokenRedirect)でforgotPasswordのエラーが書き込まれないので上書き
    if (errorDesc && errorDesc.indexOf('AADB2C90118') > -1){
      localStorage.setItem("msal.login.error", errorDesc + ":" + error);
    } 
  }

  isResetPwd():boolean {
    const authError: string = localStorage.getItem('msal.login.error') ? localStorage.getItem('msal.login.error') : null;
    return authError && authError.indexOf('AADB2C90118') > -1 
  }
  
  setPolicy(policy:string){
    //ドメインcookieにポリシーを保存する
    var index = location.host.indexOf('.'); 
    var domain =  index == -1 ? location.hostname :location.host.substring(index + 1); 
    if(policy) document.cookie = 'policy=' + policy + ';domain=' + domain + ';path=/;';    
    else document.cookie = 'policy='  + ';domain=' + domain + ';path=/;max-age=0;';    
  }

  login(policy:string, renew_policy:string = null){    
    if (location.host.split('.')[0] == 'login') return; //リダイレクトバックされたloginサブドメインでの想定外のログイン処理を回避する
    //キャッシュをクリアする
    //開発環境では他のモードのログイン状態もクリアされるが、本番環境はドメインが異なるので問題ないはず。
    this.clearCache();
    this.clearCookie();
    //履歴に追加する
    history.pushState(null,document.title,location.href);

    var authorityBase = 'https://codexid.b2clogin.com/tfp/codexid.onmicrosoft.com/' ;
    if (renew_policy)localStorage.setItem('auth', authorityBase + renew_policy);
    else localStorage.setItem('auth',authorityBase + policy);
    // this.app.authority = authorityBase + policy;プロパティ削除
    this.app.loginRedirect({scopes: this.scopes, authority: authorityBase + policy,state:this.state});
  }
  clearCookie(){
          var allCookies = document.cookie.split(';'); 
          
          // The "expire" attribute of every cookie is  
          // Set to "Thu, 01 Jan 1970 00:00:00 GMT" 
          for (var i = 0; i < allCookies.length; i++) 
              document.cookie = allCookies[i] + "=;max-age=0;";
  }
  clearCache(){
    var keys = new Array<string>();
    for(var i=0;i<localStorage.length; i++)
    {
      keys.push(localStorage.key(i));
    }
    keys.forEach(key => {
      if (key.startsWith("msal") || key.startsWith('{"authority":')) localStorage.removeItem(key);
    });
  }
  
  logout() {
    localStorage.removeItem('auth');
    localStorage.removeItem('userId');

    //シングルサインオンをクリアする ["policy=B2C_1_office365","B2C_1_office365"]
    this.setPolicy(null);

    this.app.logout();
    //ログアウトで遷移するから通らない
    // var keys = new Array<string>();
    // for(var i=0;i<localStorage.length; i++)
    // {
    //   keys.push(localStorage.key(i));
    // }
    // keys.forEach(key => {
    //   if (key.startsWith("msal") || key.startsWith('{"authority":')) localStorage.removeItem(key);
    // });
  }

  getToken() {

    //同一ブラウザ・同一ドメイン(localStorageを共有する範囲)で異なるログイン状態は許可しない=>強制的にリロードする。
    var currentUserId = localStorage.getItem('userId');
    var currentAuth = localStorage.getItem('auth');
    if (this.userId != currentUserId || this.auth != currentAuth) {
      location.reload();
    }

    //最終的なエラーは呼び出し側で行う
    //id_tokenのリニューはclientIDを渡す必要がある
    //[acquireTokenSilentの仕様]~UserAgentApplication.js =>getCachedToken
    //id_tokenの有効期限到来まで5分を切るか、指定されたauthorityのid_tokenがcashされてない場合はrenewする(リダイレクトはしないがbackgroundでリロードが発生する)。
    //※ポリシー側でid_tokenの有効期限を5分にすると無限ループが発生するので注意する。
    return this.app.acquireTokenSilent({scopes: this.scopes}).then(response=>response.idToken) //x-ms-cpim-ssoクッキーが残っているとlocalStorageは復元される
    .catch(error =>{
      this.clearCache();//renew時にcacheがクリアされないので削除する           
      return this.app.acquireTokenRedirect({scopes: this.scopes, state:this.state});
    });
  }

}

export const auth = new Auth('8cfbe406-6a59-4534-acd9-3cf5d0841624');

// function onSIApiReady() 
// {
//     //Will display the tab once the scripts have loaded
//     var userId = auth.userId;
//     var userName = auth.userName;
//     (window as any).SI_API.setChatInfo(userName,userId,null,null);
// };

// (window as any).onSIApiReady = onSIApiReady;

